import React, { CSSProperties, ReactNode } from 'react'
import './Resumen.css'
import { ResumenProvider } from './ResumenContext'
const Resumen = ({ children, style }: { children: ReactNode, style?: CSSProperties }) => {
    return (
        <ResumenProvider >
            <div className='shared__resumen' style={style}>{children}</div>
        </ResumenProvider>
    )
}

export default Resumen